import { useSelector } from "react-redux";
import { RootState } from "../Redux/Reducers";
import { IAppConstants } from "../Types/reducerTypes/commonTypes";
import { APP_CONSTANTS_DEFAULTS } from "../Constants/appConstants";

export function useAppConstants(): IAppConstants {
  const appContants = useSelector((state: RootState) => state.commonReducer.appConstants);

  return appContants || APP_CONSTANTS_DEFAULTS;
}
